<div
  #root
  class="root"
  [class.hidden]="hideImage"
  [class.native-preview-active]="hasNativeAnimatedImage"
  (resized)="onRootResized($event)">
</div>

@if (nativeAnimatedImageUrl(); as animatedImageUrl) {
  @if (!hideImage) {
    <img class="native-animated-preview" [src]="animatedImageUrl" alt="" />
  }
}

@if (previewLoading()) {
<div class="loading-overlay">
  <lib-spinner size="lg" variant="primary" />
</div>
}

@if (error) {

<div class="error-container">
  <h3>{{ error.ExceptionMessage }}</h3>
  @if (error.InnerException) {

  <h4>
    {{ error.InnerException.ExceptionMessage }}
  </h4>
  }
</div>
}
